import { render, staticRenderFns } from "./Phones.vue?vue&type=template&id=225eb9d8&scoped=true&"
import script from "./Phones.vue?vue&type=script&lang=js&"
export * from "./Phones.vue?vue&type=script&lang=js&"
import style0 from "./Phones.vue?vue&type=style&index=0&id=225eb9d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225eb9d8",
  null
  
)

export default component.exports